export default __webpack_public_path__ + "static/eKZPOPVu-c866971d9c33ce3002c81f2633cc599c.svg";